const header = document.querySelector('header-component');
const threshold = 80;

if (header) {
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > threshold);
        ticking = false;
      });
      ticking = true;
    }
  });
}